const tele = window.Telegram.WebApp
import { useState, useCallback, useEffect, useContext } from "react"
import {
  Box,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Typography,
  Checkbox,
  Paper,
  Divider,
} from "@mui/material"
import { Footer } from "components/Footer"

import { Link, useLocation, useNavigate } from "react-router-dom"
import "App.scss"
import { ButtonCounter } from "components/ButtonCounter"
import { BigButton } from "components/BigButton"
import { useNavigator } from "hooks/useNavigator"

import { useTranslation } from "react-i18next"
import i18n from "helpers/i18n"
import { getAddons, getChoices } from "helpers/api"
import Avatar from "@mui/material/Avatar"
import default_dish_img from "images/svg_dishes/pot-dinner-svgrepo-com.svg"
import isPhotoUrl from "helpers/isPhotoUrl"
import toppings_icon from "images/toppings_icon.png"

import { FlexRowContainer } from "components/AllHelpComponents"
import { CartContext } from "App"
import { LoadingOverlay } from "../components/LoadingOverlay"
import queryString from "query-string"
import changeSize from "helpers/changeSize"
import { fixScrollTop } from "helpers/scrollSaver"
import { ImageViewer } from "components/ImageViewer"

export const Product = () => {
  const { t } = useTranslation()
  const { env } = useNavigator()
  const navigate = useNavigate()
  const location = useLocation()
  const { cartItems, setCartItems, typesList, language, settings } = useContext(CartContext)
  console.log("typesList :>> ", typesList)
  console.log("cartItems1111 :>> ", cartItems)

  const food = location?.state?.food
  console.log("food Product:>> ", food)

  const exist = cartItems.find((x) => x.id === food.id)

  const query = queryString.parse(location.search)
  const dish_id = query.dish_id

  // const food = cartItems.find((x) => x.id === dish_id.id)
  // const exist = cartItems.find((x) => x.id === dish_id.id)

  const [quantityItem, setQuantityItem] = useState(exist?.quantity || 1)
  const [hasQuantityChanged, setHasQuantityChanged] = useState(false)
  const [wasInCartInitially, setWasInCartInitially] = useState(!!exist)
  const [selectedToppings, setSelectedToppings] = useState(exist?.selectedToppings || [])
  const [selectedExtras, setSelectedExtras] = useState({})
  const [selectedExtrasNames, setSelectedExtrasNames] = useState({})
  const [groupedExtras, setGroupedExtras] = useState({})

  const [addons, setAddons] = useState([])
  const [choices, setChoices] = useState([])

  const [selectedChoicesIds, setSelectedChoicesIds] = useState(exist?.selectedChoicesIds || {})
  const [selectedAddonsIds, setSelectedAddonsIds] = useState(exist?.selectedAddonsIds || {})

  useEffect(() => {
    const exist = cartItems.find((x) => x.id === food.id)

    if (exist) {
      setCartItems(
        cartItems.map((x) => (x.id === food.id ? { ...exist, quantity: exist.quantity } : x))
      )
    }

    getChoices(food.id).then((choicesData) => {
      setChoices(choicesData)

      if (!Object.keys(selectedAddonsIds).length) {
        const selected = {}
        choicesData.forEach((choiceData) => {
          selected[choiceData.id] = choiceData.options[0].id
        })

        setSelectedChoicesIds(selected)
      }
    })

    getAddons(food.id).then((addonsData) => {
      setAddons(addonsData)
    })

    console.log("cartItems", cartItems)
  }, [])

  const onAdd = () => {
    const exist = cartItems.find((x) => x.id === food.id)
    setHasQuantityChanged(true)

    if (exist) {
      setCartItems(
        cartItems.map((x) => (x.id === food.id ? { ...exist, quantity: exist.quantity + 1 } : x))
      )
      setQuantityItem(exist.quantity + 1)
    } else {
      setCartItems([...cartItems, { ...food, quantity: 1 }])
      setQuantityItem(1)
    }
  }

  const onRemove = () => {
    const exist = cartItems.find((x) => x.id === food.id)

    if (!exist) return

    setHasQuantityChanged(true)

    if (exist.quantity === 1) {
      setQuantityItem(0)
    } else {
      setCartItems(
        cartItems.map((x) => (x.id === food.id ? { ...exist, quantity: exist.quantity - 1 } : x))
      )
      setQuantityItem(exist.quantity - 1)
    }
  }

  const onDelete = useCallback(() => {
    setCartItems(cartItems.filter((x) => x.id !== food.id))
    navigate("/")
  }, [cartItems, food.id, navigate, setCartItems])

  //=================================================

  const onSubmit = useCallback(() => {
    console.log("selectedToppings", selectedToppings)
    const exist = cartItems.find((x) => x.id === food.id)

    const selectedChoices = []
    const selectedAddons = {}

    choices.forEach((choice) => {
      choice.options.forEach((option) => {
        if (option.id === selectedChoicesIds[choice.id]) {
          selectedChoices.push({ ...choice, options: [{ ...option }] })
        }
      })
    })

    addons.forEach((addon) => {
      addon.options.forEach((option) => {
        if (selectedAddonsIds[`${addon.id}_${option.id}`]) {
          if (!selectedAddons[addon.id]) {
            selectedAddons[addon.id] = { ...addon, options: [] }
          }

          selectedAddons[addon.id].options.push({ ...option })
        }
      })
    })

    const additionalData = {
      selectedToppings,
      selectedExtrasNames,
      selectedChoices,
      selectedAddons: Object.values(selectedAddons),
      selectedChoicesIds: { ...selectedChoicesIds },
      selectedAddonsIds: { ...selectedAddonsIds },
    }

    if (exist) {
      setCartItems(cartItems.map((x) => (x.id === food.id ? { ...exist, ...additionalData } : x)))
    } else {
      setCartItems([...cartItems, { ...food, quantity: 1, ...additionalData }])
    }

    navigate("/")
  }, [
    food,
    cartItems,
    choices,
    selectedChoicesIds,
    addons,
    selectedAddonsIds,
    selectedToppings,
    selectedExtrasNames,
  ])

  const onCancel = useCallback(() => {
    navigate("/")
  }, [navigate])

  //=================================================

  const onBackButtonClicked = useCallback(() => {
    navigate("/")
  }, [navigate])

  //====================================================

  const toggleTopping = (title) => {
    const exist = cartItems.find((x) => x.id === food.id)

    // Mark that changes were made (for items already in cart)
    if (wasInCartInitially) {
      setHasQuantityChanged(true)
    }

    if (exist) {
      const updatedToppings = exist.toppings.map((topping) => {
        if (topping.title === title) {
          return { ...topping, count: topping.count === 0 ? 1 : 0 }
        }
        return topping
      })

      console.log("updatedToppings", updatedToppings)

      // Update the item in the cart with the updated toppings
      const updatedCartItems = cartItems.map((item) =>
        item.id === exist.id ? { ...exist, toppings: updatedToppings } : item
      )

      // Update the cart items state
      setCartItems(updatedCartItems)
    }

    const isToppingSelected = selectedToppings.includes(title)

    if (isToppingSelected) {
      setSelectedToppings(selectedToppings.filter((topping) => topping !== title))
    } else {
      setSelectedToppings([...selectedToppings, title])
    }
  }

  //================================================

  // Обработчики изменения выбранных опций для каждого типа

  const getTypeValue = (type) => {
    console.log("type2222 :>> ", type)
    console.log("selectedExtras type2222 :>> ", selectedExtras)
    console.log("selectedExtrasNames type2222 :>> ", selectedExtrasNames)
    console.log("cartItems type2222 :>> ", cartItems)
    // selectedExtrasNames[type] || ""
    selectedExtras[type] || ""
  }

  // const getTypeValue = (type) => selectedExtras[type] || ""

  useEffect(() => {
    function groupExtrasByType(extras) {
      if (extras.length === 0) {
        return null
      }

      const grouped = {}

      for (const extra of extras) {
        const { type_id } = extra
        const type_name = typesList.find((type) => type.id === type_id)?.type

        console.log("typesList :>> ", typesList)
        if (!grouped[type_name]) {
          grouped[type_name] = []
        }
        grouped[type_name].push(extra)
      }

      return grouped
    }

    if (typesList.length > 0) {
      const groupedExtras = groupExtrasByType(food.extras)

      setGroupedExtras(groupedExtras) // Обновление состояния groupedExtras
    }
  }, [typesList])

  useEffect(() => {
    console.log("cartItems?.selectedExtrasNames :>> ", cartItems?.selectedExtrasNames)
    // cartItems?.selectedExtrasNames?.length > 0 &&
    setSelectedExtrasNames(cartItems?.selectedExtrasNames)
    fixScrollTop()
  }, [])

  // const handleExtrasChange = (type, title) => {
  //   toggleExtras(title, type) // Вызов toggleExtras с передачей типа и названия опции
  // }

  const toggleExtras = (title, type) => {
    const exist = cartItems.find((x) => x.id === food.id)

    // Mark that changes were made (for items already in cart)
    if (wasInCartInitially) {
      setHasQuantityChanged(true)
    }

    if (exist) {
      const updatedExtras = exist.extras.map((extra) => {
        if (extra.title === title && extra.type === type) {
          return { ...extra, count: extra.count === 0 ? 1 : 0 }
        }
        return extra
      })

      // Обновление товара в корзине с обновленными дополнительными опциями
      const updatedCartItems = cartItems.map((item) =>
        item.id === exist.id ? { ...exist, extras: updatedExtras } : item
      )

      // Обновление состояния корзины
      setCartItems(updatedCartItems)
    }

    console.log("title :>> ", title)

    const selectedExtraId = title
    const selectedExtra = food.extras.find((extra) => String(extra.id) === String(selectedExtraId))

    console.log("selectedExtra?.title :>> ", selectedExtra?.title)
    setSelectedExtrasNames({
      ...selectedExtrasNames,
      [type]: selectedExtra?.title || "",
    })

    setSelectedExtras({
      ...selectedExtras,
      [type]: title, // В противном случае, выбрать опцию
    })
    // }
  }

  const toggleChoices = useCallback((e) => {
    const { name, value } = e.target
    const choiceId = name.split("_")[1]

    // Mark that changes were made (for items already in cart)
    if (wasInCartInitially) {
      setHasQuantityChanged(true)
    }

    setSelectedChoicesIds((selected) => ({ ...selected, [choiceId]: +value }))
  }, [wasInCartInitially])

  const toggleAddons = useCallback((e) => {
    const { name, checked } = e.target
    const [, addonId, optionId] = name.split("_")

    // Mark that changes were made (for items already in cart)
    if (wasInCartInitially) {
      setHasQuantityChanged(true)
    }

    setSelectedAddonsIds((selected) => ({
      ...selected,
      [`${addonId}_${optionId}`]: checked,
    }))
  }, [wasInCartInitially])

  useEffect(() => {
    // Получение начального значения selectedExtrasNames из cartItems
    const exist = cartItems.find((x) => x.id === food.id)
    if (exist && exist.selectedExtrasNames) {
      setSelectedExtrasNames(exist.selectedExtrasNames)
    }
  }, [])

  return (
    <>
      {!cartItems && <LoadingOverlay />}
      <Box sx={{ maxWidth: "100%", margin: "0 auto", p: 2, paddingBottom: "124px" }}>
        {/* Кнопка возврата */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box
            onClick={onCancel}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              padding: "8px 16px",
              borderRadius: "8px",
              backgroundColor: "#1a222c",
              border: "2px solid #2e30adff",
              color: "#5cb8ffff",
              fontWeight: "600",
              fontSize: "1rem",
              transition: "all 0.2s",
              "&:hover": {
                backgroundColor: "#2e30adff",
                borderColor: "#5cb8ffff",
              },
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: "1.5rem",
                lineHeight: 1,
              }}
            >
              ←
            </Box>
            <Box component="span">{t("Back")}</Box>
          </Box>
        </Box>

        {/* Заголовок продукта */}
        <Typography
          variant="h4"
          align="center"
          sx={{
            mb: 3,
            fontWeight: "bold",
            color: "#f4f5f5",
            letterSpacing: 0.5,
            fontSize: {
              xs: '1.5rem',
              sm: '1.8rem',
              md: '2rem',
              lg: '2.2rem',
            },
          }}
        >
          {food.translations && food.translations[language]
            ? food.translations[language]
            : food.title}
        </Typography>

        {/* Карточка с изображением и информацией о продукте */}
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            background: "#1a222c",
            border: "1px solid #2e30adff",
            borderRadius: "8px",
            overflow: "hidden"
          }}
        >
          {/* Изображение продукта */}
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            width: "100%",
            maxHeight: "400px",
            backgroundColor: "#131415",
          }}>
            <ImageViewer imgUrls={isPhotoUrl(food.image) ? [food.image] : null}>
              <Box
                component="img"
                src={isPhotoUrl(food.image) ? changeSize(food.image, 450, 300) : default_dish_img}
                alt={food.title}
                sx={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              />
            </ImageViewer>
          </Box>

          {/* Информация о продукте */}
          <Box sx={{ p: 2.5 }}>
            {/* Описание */}
            {(food.translations_descriptions?.[language] || food.description) && (
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#b1bfcf",
                    fontSize: "1rem",
                    lineHeight: 1.6,
                    wordWrap: "break-word",
                    hyphens: "auto",
                  }}
                >
                  {food.translations_descriptions?.[language] ?? food.description}
                </Typography>
              </Box>
            )}

            <Divider sx={{ my: 2, borderColor: "#2e30adff" }} />

            {/* Цена */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="h6"
                fontWeight="600"
                sx={{ color: "#f4f5f5" }}
              >
                {t("Price:")}
              </Typography>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ color: "#5cb8ffff" }}
              >
                {food.price?.toFixed(2)}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
              </Typography>
            </Box>
          </Box>
        </Paper>

        {/* Счетчик количества убран отсюда, перенесен в футер */}

        {choices.length ? (
          <Paper
            elevation={0}
            sx={{
              mb: 3,
              background: "#1a222c",
              border: "1px solid #2e30adff",
              borderRadius: "8px",
              overflow: "hidden"
            }}
          >
            <Box sx={{
              py: 1.5,
              px: 2,
              backgroundColor: "#1a222c",
              borderBottom: "1px solid #2e30adff"
            }}>
              <Typography
                variant="subtitle1"
                fontWeight="600"
                sx={{ color: "#5cb8ffff" }}
              >
                {t("Choices")}
              </Typography>
            </Box>

            <Box sx={{ p: 2 }}>
              {choices.map((choice) => {
                return (
                  <Box key={choice.id} sx={{ mb: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "#f4f5f5",
                        fontWeight: 600,
                        mb: 1.5
                      }}
                    >
                      {choice.name_translations?.[language] || choice.name}
                    </Typography>

                    <FormControl component="fieldset" fullWidth>
                      <RadioGroup
                        name={`choice_${choice.id}`}
                        value={selectedChoicesIds[choice.id]}
                        onChange={toggleChoices}
                      >
                        {choice.options.map((option) => (
                          <FormControlLabel
                            key={option.id}
                            value={option.id}
                            label={`${option.name_translations?.[language] || option.name}${option.price && settings?.currency?.symbol ? ` + ${settings.currency.symbol}${option.price}` : option.price ? ` + ${option.price}` : ""}`}
                            control={
                              <Radio
                                checked={selectedChoicesIds[choice.id] === option.id}
                                sx={{
                                  color: "#b1bfcf",
                                  "&.Mui-checked": {
                                    color: "#5cb8ffff",
                                  },
                                }}
                              />
                            }
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                color: "#f4f5f5",
                                fontSize: "0.95rem",
                              },
                            }}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </Box>
                )
              })}
            </Box>
          </Paper>
        ) : null}

        {addons.length ? (
          <Paper
            elevation={0}
            sx={{
              mb: 3,
              background: "#1a222c",
              border: "1px solid #2e30adff",
              borderRadius: "8px",
              overflow: "hidden"
            }}
          >
            <Box sx={{
              py: 1.5,
              px: 2,
              backgroundColor: "#1a222c",
              borderBottom: "1px solid #2e30adff"
            }}>
              <Typography
                variant="subtitle1"
                fontWeight="600"
                sx={{ color: "#5cb8ffff" }}
              >
                {t("Addons")}
              </Typography>
            </Box>

            <Box sx={{ p: 2 }}>
              {addons.map((addon) => {
                return (
                  <Box key={addon.id} sx={{ mb: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "#f4f5f5",
                        fontWeight: 600,
                        mb: 1
                      }}
                    >
                      {addon.name_translations?.[language] || addon.name}
                    </Typography>

                    {addon.max_quantity && addon.options.length > addon.max_quantity && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#b1bfcf",
                          mb: 1,
                          display: "block",
                          fontSize: "0.85rem"
                        }}
                      >
                        {`${t("Maximum of selected")}: ${addon.max_quantity}`}
                      </Typography>
                    )}

                    <FormControl component="fieldset" fullWidth>
                      {addon.options.map((option) => {
                        const isDisabled =
                          !selectedAddonsIds[`${addon.id}_${option.id}`] &&
                          addon.max_quantity &&
                          Object.keys(selectedAddonsIds).filter(
                            (id) => id.indexOf(`${addon.id}`) === 0 && selectedAddonsIds[id]
                          ).length === addon.max_quantity

                        return (
                          <FormControlLabel
                            key={option.id}
                            label={`${option.name_translations?.[language] || option.name}${option.price !== 0 && settings?.currency?.symbol ? ` + ${settings.currency.symbol}${option.price}` : option.price !== 0 ? ` + ${option.price}` : ""}`}
                            control={
                              <Checkbox
                                name={`addon_${addon.id}_${option.id}`}
                                checked={selectedAddonsIds[`${addon.id}_${option.id}`]}
                                onChange={!isDisabled ? toggleAddons : () => {}}
                                disabled={isDisabled}
                                sx={{
                                  color: isDisabled ? "#555" : "#b1bfcf",
                                  "&.Mui-checked": {
                                    color: "#5cb8ffff",
                                  },
                                }}
                              />
                            }
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                color: isDisabled ? "#888" : "#f4f5f5",
                                fontSize: "0.95rem",
                              },
                            }}
                          />
                        )
                      })}
                    </FormControl>
                  </Box>
                )
              })}
            </Box>
          </Paper>
        ) : null}
      </Box>

      {/* Buttons */}
      {env == "browser" && (
        <Footer>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              padding: "10px",
            }}
          >
            {/* Left side: Quantity controls */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                minWidth: "120px",
              }}
            >
              <Box
                onClick={onRemove}
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#dc3545",
                  color: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  border: "2px solid #000",
                  "&:hover": {
                    backgroundColor: "#c82333",
                  },
                }}
              >
                −
              </Box>

              <Box
                sx={{
                  minWidth: "50px",
                  textAlign: "center",
                  border: "2px solid #5cb8ffff",
                  borderRadius: "6px",
                  padding: "6px 12px",
                  backgroundColor: "#1a222c",
                  color: "#f4f5f5",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                }}
              >
                {quantityItem}
              </Box>

              <Box
                onClick={onAdd}
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#28a745",
                  color: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  border: "2px solid #000",
                  "&:hover": {
                    backgroundColor: "#218838",
                  },
                }}
              >
                +
              </Box>
            </Box>

            {/* Right side: Delete, Add to Order, or Update button */}
            <Box sx={{ flex: 1, display: "flex", gap: 1 }}>
              {!wasInCartInitially ? (
                // If item was NOT in cart initially - always show "Add to Order" (blue)
                <Box
                  onClick={onSubmit}
                  sx={{
                    flex: 1,
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#5cb8ffff",
                    color: "white",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    border: "4px solid #000",
                    "&:hover": {
                      backgroundColor: "#4a9de5",
                    },
                  }}
                >
                  {t("Add to Order")}
                </Box>
              ) : !hasQuantityChanged ? (
                // If item WAS in cart initially but quantity not changed - show "Delete" (red)
                <Box
                  onClick={onDelete}
                  sx={{
                    flex: 1,
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#dc3545",
                    color: "white",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    border: "4px solid #000",
                    "&:hover": {
                      backgroundColor: "#c82333",
                    },
                  }}
                >
                  {t("Delete")}
                </Box>
              ) : (
                // If item WAS in cart initially AND quantity changed - show "Update Order" (blue)
                <Box
                  onClick={onSubmit}
                  sx={{
                    flex: 1,
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#5cb8ffff",
                    color: "white",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    border: "4px solid #000",
                    "&:hover": {
                      backgroundColor: "#4a9de5",
                    },
                  }}
                >
                  {t("Update Order")}
                </Box>
              )}
            </Box>
          </Box>
        </Footer>
      )}
    </>
  )
}
